// extracted by mini-css-extract-plugin
module.exports = {"button__loading":"ButtonGoToPay_button__loading__pVNaL"};